export enum TERM {
  TERMS,
  PRIVACY_POLICY,
  NEWSLETTER,
}
